import * as requestsAccountingActionCreators from '../../../redux/modules/requests-accounting';
import * as exchangeRateReducer from '../../../redux/modules/exchangeRate';
import * as authActions from "../../../redux/modules/auth";

const mapStateToProps = state => ({
  pageCount: state.requestsForAccounting.pageCount,
  requestStore: state.requestsForAccounting,
  exchangeRate: state.exchangeRate,
  isOverLimitCheckExist: state.auth.user.isOverLimitCheckExist,
  isActive: state.auth.isActive,
});

const mapDispatchToProps = {
  ...requestsAccountingActionCreators,
  ...exchangeRateReducer,
  ...authActions,
};

export default [mapStateToProps, mapDispatchToProps];



// WEBPACK FOOTER //
// ./src/containers/accounting/request-page/index.js